export default __webpack_public_path__ + "static/media/garden.547d0c21.webp";